import { TagGroupInfo } from './vo/tag-group-info.model';
import { KYMW0002OutputModel } from './vo/kymw0002-output.model';
/**
 * タグ選択画面の値を管理するクラス
 *
 * @export KYMW0002Model
 * @class KYMW0002Model
 */
export class KYMW0002Model {
  // タググループ一覧
  public tagGroupListOrigin: TagGroupInfo[] = [];
  public tagGroupListForEdit: TagGroupInfo[] = [];

  // タグ名
  public tagNameList: string[] = [];
  // 選択済タグID
  public selectedTagIdList: string[] = [];
  // 連携用データ
  public output: KYMW0002OutputModel = null;

  get dspTagGroupList(): TagGroupInfo[] {
    return this.tagGroupListForEdit.filter(_g => _g.tags.length > 0);
  }
}
